import c from './havn.module.scss';
import c2 from '../../batglede/batglede.module.scss';
import Helpers from "../../helpers/Helpers";
import React, {useContext, useEffect, useState} from "react";
import LinkIconUIKit from "../../svg/UIKit/LinkIconUIKit";
import MailIconUIKit from "../../svg/UIKit/MailIconUIKit";
import PhoneIconUIKit from "../../svg/UIKit/PhoneIconUIKit";
import Wave3 from "../../svg/Wave3";
import SiteService from "../../services/SiteService";
import HarbourService from "../../services/HarbourService";
import {Link, useParams} from "react-router-dom";
import UserContext from "../../store/userContext";
import siteService from "../../services/SiteService";
import StarIcon from "../../svg/StarIcon";
import ArticleImageGallery from "../articleEdit2/rendered/ArticleImageGallery";
import BackButton from "../ui/BackButton";
import OnTopBox from "../ui/onTopBox";
import Loginbox from "../ui/functional/Loginbox";

export default function HavnPage(){
	const { role, isLoggedIn } = useContext(UserContext);
	const isAdmin = (role > 0);
	const params = useParams();
	const [harbour, setHarbour] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const [isAskingLogin, setIsAskingLogin] = useState(false);


	let galleryImages = [];
	if (harbour) {
		if (harbour.image) galleryImages.push({value: `${siteService.apiPath}/image/harbour/${harbour._id}/${harbour.image}`});
		if (harbour.images && harbour.images.length > 0) galleryImages = galleryImages.concat(harbour.images.map((img, i) => {
			return {value: `${siteService.apiPath}/image/harbour/${harbour._id}/${img}`}
		}))
	}

	const fetchHarbour = async () => {
		setIsLoading(true); // Set loading state at the beginning
		try {
			const harbours = await Helpers.searchPaginated('harbour',{ name: params.harbourName },0);
			setHarbour(harbours.mainObj[0]);
		} catch (error) {
			console.error('Error fetching harbour:', error);
			setHarbour(null);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		setHarbour(null);
		setIsLoading(true);
		fetchHarbour();
	}, [params.harbourName]);


	function Description() {
		if (!harbour.description) return null;
		return <div className={c.description} dangerouslySetInnerHTML={{__html: harbour.description}}>
		</div>
	}

	const rate = async (rating)=>{
		if (!isLoggedIn) return setIsAskingLogin(true);
		let req = await Helpers.postJSON(`${siteService.apiPath}/harbour/${harbour._id}/rate`, {rating:rating});
		if (typeof req !== 'undefined') {
			if(req.averageRating) {
				setHarbour({...harbour, averageRating: req.averageRating});
			}
		}
	}
	const [ratingHover, setRatingHover] = useState(null);
	function Rating() {
		let starEls = [];
		for (let i = 0; i < 5; i++){
			let average = Math.round(harbour.averageRating)
			let fill = i<average?'#ecae1a':'';
			if (ratingHover!==null&&ratingHover >= i) {
				fill = '#d8d837';
			}
			starEls.push(<StarIcon fill={fill}
							   stroke={i<average?'white':'#c5c500'}
							   onClick={() => {rate(i+1)}} key={i}
							   onHover={() => setRatingHover(i)}
			/>)
		}
		return <div className={c.rating}>
			<div className={c.ratingTitle}><b>Vurdering</b></div>
			<br/>
			<div className={c.ratingStars} onMouseOut={()=>setRatingHover(null)}>
				{starEls}
			</div>
		</div>
	}

	function ContactSection() {
		if (!harbour.phoneNumber && !harbour.email && !harbour.website)
			return null;
		return <div className={c2.contactSection}>
			{(harbour.phoneNumber || harbour.email) && <h2>Kontakt oss</h2>}
			<div className={c2.contacts}>
				{harbour.phoneNumber && <a href={"tel:+47" + harbour.phoneNumber}>
					<PhoneIconUIKit height={'100%'}/>{harbour.phoneNumber}</a>}
				{harbour.email && <a href={"mailto:" + harbour.email}>
					<MailIconUIKit height={'100%'}/>{harbour.email}</a>}
				{harbour.website && <a target={"_blank"}
									   href={harbour.website.startsWith('http') ? harbour.website : `https://${harbour.website}`}>
					<LinkIconUIKit height={'100%'}/>{harbour.website.split('//')[1] || harbour.website}</a>}
			</div>
		</div>
	}

	function LinksSection() {
		if (!harbour.links || harbour.links.length < 1)
			return null;
		return <div className={c2.linksSection}>
			{(harbour.phoneNumber || harbour.email) && <h2>Nyttige lenker</h2>}
			<div className={c2.contacts}>
				{harbour.links.map((link, i) => {
					return <a key={i} href={link.link} target={"_blank"}>{link.text}</a>
				})}
			</div>
		</div>
	}

	function FacilitiesSection() {
		if (harbour.facilities.length === 0) return null;

		const facilityIcons = {
			"ferskvann": "🚰",
			"overnatting": "🛏️",
			"badeplass": "🏖️",
			"internett": "📶",
			"mat-servering": "☕",
			"bensin": "⛽",
			"diesel": "🛢️",
			"tørketrommel": "🌀",
			"dagligvarer": "🛒",
			"buss": "🚌",
			"lekeplass": "🎠",
			"septiktømming": "💩",
			"landstrøm": "🔌",
			"vinmonopol": "🍷",
			"serverdigheter": "🏰",
			"søppelcontainer": "🗑️",
			"is/kjøleelement": "❄️",
			"toalett": "🚻",
			"bankautomat": "🏧",
			"turistinfo": "ℹ️",
			"lege": "🩺",
			"dusj": "🚿",
			"båtutstyr": "⛵",
			"oljetømming": "🛢️",
			"slipp": "🛠️",
			"vaskemaskin": "🧺",
			"veterinær": "🐾",
			"apotek": "💊",
			"minigolf": "⛳️",
			"golf innenfor 10km": "🏌️‍",
			"grillplass": "🔥",
			"museum/galleri": "🎨",
			"verksted/reparasjon": "🛠️"
		};

		return (
			<div className={c.facilitiesContainer}>
				<h2>Fasiliteter</h2>
				<div className={c.facilities}>
					{harbour.facilities.map((facility, i) => {
						const icon = facilityIcons[facility.type];
						return (
							<div key={i} className={c.facility}>
								<div className={c2.facilityType}>{icon && <span>{icon+' '}</span>}{facility.type}</div>
								<div className={c2.facilityText}>{facility.text}</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}


	function Info(){
		if(!harbour.guestSpotsAmount && !harbour.maxDepthMeters) return null;
		return <div className={c.info}>
			{harbour.guestSpotsAmount && <div className={c.infoItem}>
				<label>Gjesteplasser</label>
				{harbour.guestSpotsAmount}
			</div>}
			{harbour.maxDepthMeters && <div className={c.infoItem}>
				<label>Max dybde</label>
				{harbour.maxDepthMeters} meter
			</div>}
		</div>
	}

	function MissingImagePrompt(){
		if (harbour.image) return null;
		return <div className={c2.missingImagePrompt}>
			<p>Denne havnen mangler bilde. Har du bilde av havnen og har rettigheter til dette, send oss ett til EKSEMPEL.
			<br/>Har du også mer info? Send oss gjerne beskrivelse, relevante lenker, eller en liste med fasiliteter.</p>
		</div>
	}

	if (isLoading) return <div className={'centered'}></div>
	return (
		<div className={[c.root, c2.exhibitorPage, 'fade-in'].join(' ')}>
			{isAskingLogin && <OnTopBox onTopEnabled={isAskingLogin} setOnTopEnabled={setIsAskingLogin} children={<><h2>Du må være logget inn for å vurdere en havn</h2><Loginbox/></>}/>}
			{isAdmin && <div className={c2.settingsBand}>
				<Link to={'/admin/havner/' + harbour._id}
					  className={'frontpageEdit-settingsBand-link'}>Rediger</Link>
				<button onClick={()=>{HarbourService.delete(harbour._id)}}>Slett</button>
			</div>}
			<div className={c2.header}
				 style={{backgroundImage: harbour.image?`url("${SiteService.apiPath}/image/harbour/${harbour._id}/${harbour.image ? harbour.image : 'header.webp'}")`:``}}>
				<BackButton fallbackPath={'/havner'} children={'Alle havner'}/>
				<h1 className={c2.logo ? 'hidden' : ''}>{harbour.name ? harbour.name : 'Havn navn'}</h1>
				<div className={c.logoContainer}>
					<h1>{harbour.name ? harbour.name : 'Havn navn'}</h1>
				</div>
				<Wave3 className={c2.wave3}/>
			</div>

			<div className={c2.exhibitorPageContent}>

				<MissingImagePrompt/>
				<div className={c.section1}>
					<div className={c.section1_1}>
						{harbour.address && <div className={c.address}>
							{/*<label>Adresse:</label>*/}
							{harbour.address}
						</div>}
						<Description/>
						<ContactSection/>
						<LinksSection/>
					</div>
					<div className={c.section1_2}>
						<Rating/>
						<Info/>
						<FacilitiesSection/>
					</div>
					<div>
						<h2>Galleri</h2>
						<ArticleImageGallery images={galleryImages}/>
					</div>
				</div>

			</div>

			<br/>
		</div>
	)
}